// extracted by mini-css-extract-plugin
export default {"btns":"View_btns__U0+TO","button":"View_button__JeSyb","description":"View_description__KeZYL"};